import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "wouter";


export function MainContent(props: { backLink: string; children?: React.ReactNode }) {
    const [, navigate] = useLocation();
    return <div className="main-content">
        <div className="close-button" onClick={() => navigate(props.backLink)}>
            <FontAwesomeIcon icon={faClose} />
        </div>
        <div className="main-content-inner">
            {props.children}
        </div>
    </div>;
}
